<template>
  <v-card class="mx-2 mt-2" outlined>
    <v-tabs fixed-tabs v-model="tab">
      <v-tab class="ml-0">{{ $t('ELE0213') }}</v-tab>
      <v-tab>{{ $t('ELE0028') }}</v-tab>
      <v-tab-item class="pl-2 pt-1 pb-4">
        <v-row dense>
          <v-col cols="6">
            <InspQRCodeInput v-model="qrCodeComputed" required @scanned="search" @error="reset" />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="pl-2 pt-1 pb-4">
        <validation-observer v-slot="{ invalid }">
          <v-row dense>
            <v-col cols="3">
              <ManufacturerInput :label="$t('ELE0057')" v-model="manufacturerCdComputed" required />
            </v-col>
            <v-col cols="2">
              <TextFieldInput :label="$t('ELE0049')" v-model="lotNoComputed" required />
            </v-col>
            <v-col cols="2">
              <TextFieldInput :label="$t('ELE0031')" v-model="partCdComputed" required />
            </v-col>
            <v-col cols="3">
              <CompanyInput
                v-model="inspCompanyCdComputed"
                :label="$t('ELE0048')"
                :companyCatCd="userCompanyCatCd"
                :companyType="companyType"
                :disabled="isSupplier"
                validOnly
                required
              />
            </v-col>
            <v-col>
              <BtnSearch class="mx-2 mt-2" @click="onClickSearch" :disabled="invalid" />
            </v-col>
          </v-row>
        </validation-observer>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import { OqcIqcCd } from '@/enum'

import BtnSearch from '@/components/atoms/button/BtnSearch'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import InspQRCodeInput from '@/components/atoms/text-field/InspQRCodeInput'
import ManufacturerInput from '@/components/atoms/select/ManufacturerInput'
import CompanyInput from '@/components/atoms/select/CompanyInput'

export default {
  name: 'SearchInspConditionForm',

  mixins: [APIUtils, Message, Loading],

  components: {
    ValidationObserver,
    BtnSearch,
    TextFieldInput,
    TextFieldRef,
    InspQRCodeInput,
    ManufacturerInput,
    CompanyInput,
  },

  props: {
    qrCode: {
      type: String,
      required: false,
      default: '',
    },
    manufacturerCd: {
      type: String,
      required: false,
      default: '',
    },
    lotNo: {
      type: String,
      required: false,
      default: '',
    },
    partCd: {
      type: String,
      required: false,
      default: '',
    },
    inspCompanyCd: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      userCompanyCatCd: this.$store.getters.companyCatCd,
      tab: '',
    }
  },

  computed: {
    companyType() {
      return this.$store.getters.companyInspCat
    },
    isSupplier() {
      return this.$store.getters.isSupplier
    },
    qrCodeComputed: {
      get() {
        return this.qrCode
      },
      set(value) {
        this.$emit('update:qrCode', value)
      },
    },
    manufacturerCdComputed: {
      get() {
        return this.manufacturerCd
      },
      set(value) {
        this.$emit('update:manufacturerCd', value)
      },
    },
    lotNoComputed: {
      get() {
        return this.lotNo
      },
      set(value) {
        this.$emit('update:lotNo', value)
      },
    },
    partCdComputed: {
      get() {
        return this.partCd
      },
      set(value) {
        this.$emit('update:partCd', value)
      },
    },
    inspCompanyCdComputed: {
      get() {
        return this.inspCompanyCd
      },
      set(value) {
        this.$emit('update:inspCompanyCd', value)
      },
    },
  },

  methods: {
    async onClickSearch() {
      try {
        this.startLoading()

        let inspTimingCd = OqcIqcCd.IQC
        if (this.manufacturerCdComputed == this.$store.getters.companyCd) {
          inspTimingCd = OqcIqcCd.OQC
        }

        const inspIndex = await API.get('/inspIndex/inspTarget', {
          inspTimingCd: inspTimingCd,
          manufacturerCd: this.manufacturerCdComputed,
          lotNo: this.lotNoComputed,
          partCd: this.partCdComputed,
          userCompanyCd: this.$store.getters.companyCd,
          inspCompanyCd: this.inspCompanyCdComputed,
        })

        this.search(inspIndex.inspIndexNo)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
        this.reset()
      } finally {
        this.stopLoading()
      }
    },

    search(inspIndexNo) {
      this.$emit('search', inspIndexNo)
    },

    reset() {
      this.$emit('reset')
    },
  },
}
</script>
